
import React, { useEffect } from 'react'
import { use } from 'react';
import { createContext, useState } from "react";
import { useLocation, useParams } from 'react-router-dom';
export const themeContext = createContext(null);

const ThemeGlobalState = ({ children }) => {
    const [themeValue, setThemeValue] = useState(false);
    const [currentPath, setCurrentPath] = useState("");
    const params = useLocation();
    console.log('currentPath', currentPath)
    const handleThemeChange = () => {
        if (currentPath !== "launchpad") {
            setThemeValue(!themeValue);
        }
    }
    useEffect(() => {
        if (params) {
            const path = params.pathname.split("/").filter((item) => item !== "")[0]
            setCurrentPath(path);
        }
    }, [params])
    useEffect(() => {
        if (themeValue) {
            // if (currentPath !== "launchpad") {
            document.body.classList.remove("dark-mode");
            localStorage.setItem("theme", "light");
            // }
        } else {
            // if (currentPath !== "launchpad") {
            document.body.classList.add("dark-mode");
            localStorage.setItem("theme", "dark");
            // }
        }
    }, [themeValue, currentPath]);

    const ThemeFunction = () => {
        const savedTheme = localStorage.getItem("theme");
        if (savedTheme === "dark") {
            if (currentPath !== "launchpad") {
                setThemeValue(true);
                document.body.classList.add("dark-mode");
            }
        }
    }
    useEffect(() => {
        ThemeFunction();
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0);
        if (currentPath == "launchpad") {
            console.log('currentPath', currentPath == "launchpad")
            document.body.classList.add("rubixTheme");
            // document.body.classList.remove("dark-mode");
            // setThemeValue(false);
        } else {
            console.log('currentPath', currentPath == "launchpad")
            document.body.classList.remove("rubixTheme");
            // setThemeValue(true);
            // ThemeFunction();
        }
    }, [currentPath]);

    return (
        <themeContext.Provider value={{ themeValue, handleThemeChange }}>
            {children}
        </themeContext.Provider>
    )
}

export default ThemeGlobalState;
